import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import {
  IconSizeEnum, SdHtmlComponent, SdIconComponent, SdSkeletonComponent, SdThemeComponent,
  SdTitleComponent, SkeletonAppearanceEnum
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdIconComponent,
    SdTitleComponent,
    SdSkeletonComponent,
    SdHtmlComponent
  ]
})
export class SdTipsComponent extends SdThemeComponent {
  @Input()
  isLoading = false;

  @Input()
  title: string;

  @Input()
  titleLevel: number;

  @Input()
  content: string;

  @Input()
  icon: string;

  IconSize = IconSizeEnum;
  SkeletonAppearanceEnum = SkeletonAppearanceEnum;
}
